import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ClickOutsideDirective } from '../directives/click-outside.directive';
import { Language, LanguageService } from '../services/language.service';

@Component({
  selector: 'app-language-switcher',
  standalone: true,
  imports: [CommonModule, ClickOutsideDirective, TranslateModule],
  templateUrl: './language-switcher.component.html',
  styleUrl: './language-switcher.component.css',
})
export class LanguageSwitcherComponent implements OnInit {
  @Input() textClass: string = 'text-white';
  
  currentLanguageObj!: Language;
  languages: Language[] = [];
  isDropdownOpen = false;

  constructor(private languageService: LanguageService) {}

  ngOnInit(): void {
    this.languages = this.languageService.getAllLanguages();
    this.currentLanguageObj = this.languageService.getCurrentLanguage();
    
    // Subscribe to language changes
    this.languageService.currentLanguage$.subscribe(language => {
      this.currentLanguageObj = language;
    });
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  selectLanguage(language: Language) {
    this.languageService.setLanguage(language.code);
    this.isDropdownOpen = false;
  }

  closeDropdown() {
    this.isDropdownOpen = false;
  }

  getLocalizedName(language: Language): string {
    return this.languageService.getLocalizedLanguageName(language);
  }
}
